export default "data:image/gif;base64,R0lGODlhEgAMAPAAAP8AAP/XACH5BAAAAAAALAAAAAASAAwAAAIThI+py90Bo5y02ouz3jy6D4ZMAQA7"